/* istanbul ignore file */
import { themeGet } from "@styled-system/theme-get";

const customStyles = ({ theme }) => ({
  menu: (provided) => ({
    ...provided,
    backgroundColor: "transparent",
    color: themeGet("colors.subText")({ theme }),
    fontSize: themeGet("fontSizes.0")({ theme }),
    border: "none",
    borderRadius: "0",
    overflow: "visible",
    zIndex: 101,
    boxShadow: "none",
    marginBottom: "0",
    left: "0",
    width: `calc(100% + ${themeGet("appScale.sideNavSize")({ theme })} + 11px)`,
    minWidth: "220px",
  }),
  menuList: (provided) => ({
    ...provided,
    overflow: "auto",
    color: themeGet("colors.subText")({ theme }),
    backgroundColor: themeGet("colors.white")({ theme }),
    border: `1px solid ${themeGet("colors.surfaceRaisedBorder")({ theme })}`,
    marginTop: themeGet("space.s")({ theme }),
    boxShadow: themeGet("shadows.boxDefault")({ theme }),
    borderRadius: themeGet("radii.2")({
      theme,
    }),
    padding: themeGet("space.xs")({
      theme,
    }),
  }),
  control: (provided) => ({
    ...provided,
    cursor: "pointer",
    height: "20px",
    minHeight: "20px",
    border: "none",
    backgroundColor: "transparent",
    fontSize: themeGet("fontSizes.0")({ theme }),
    overflow: "hidden",
    boxShadow: "none",
    "svg path": {
      transition: "fill 300ms ease-in-out",
    },
    "[class*='singleValue']": {
      transition: "color 300ms ease-in-out",
    },
    "&:focus-within, &:hover": {
      outline: "none",
      "svg path": {
        fill: themeGet("colors.primary")({ theme }),
      },
      "[class*='singleValue']": {
        color: themeGet("colors.primary")({ theme }),
      },
    },
  }),
  container: (provided) => ({
    ...provided,
    fontSize: themeGet("fontSizes.0")({ theme }),
    height: "20px",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: themeGet("fontSizes.0")({ theme }),
    color: themeGet("colors.subText")({ theme }),
    marginLeft: "0",
    maxWidth: "210px",
    marginRight: "0",
    position: "relative",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: themeGet("space.xxs")({ theme }),
    color: themeGet("colors.subText")({ theme }),
    "&:hover": {
      color: themeGet("colors.danger")({ theme }),
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    "> div": {
      padding: "0",
      height: "auto",
      "> svg": {
        height: "15px",
        width: "15px",
      },
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: themeGet("space.xxs")({ theme }),
    color: themeGet("colors.subText")({ theme }),
    "&:hover": {
      color: themeGet("colors.primary")({ theme }),
    },
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    borderRadius: state.isSelected
      ? themeGet("radii.2")({ theme })
      : "transparent",
    backgroundColor: state.isSelected
      ? themeGet("colors.primaryLightest")({ theme })
      : "transparent",
    fontSize: themeGet("fontSizes.0")({ theme }),
    color: state.isSelected
      ? themeGet("colors.bodyText")({ theme })
      : themeGet("colors.subText")({ theme }),
    whiteSpace: "break-spaces",
    padding: `${themeGet("space.xs")({ theme })} ${themeGet("space.s")({
      theme,
    })}`,
    marginBottom: "4px",
    transition: "all 200ms ease-in-out",
    "&:hover": {
      backgroundColor: themeGet("colors.primaryLightest")({ theme }),
      borderRadius: themeGet("radii.2")({ theme }),
    },
    "&:last-of-type": {
      marginBottom: "0",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: themeGet("colors.subText")({ theme }),
    fontSize: themeGet("fontSizes.0")({ theme }),
  }),
});

export default customStyles;
